var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../libs/Model');
var loaders = require('../layout/components/loaders');
var verticalListItem = require('./verticalListItem');
var paginationWithSearch = require('../data/components/paginationWithSearch');

function urlForRecord (record) {
  if(record)
    return '/api/v1/site/' + record['@rid'].slice(1);
  else 
    return 'api/v1/dashboard';
}

function getChildVertex(edge) {
  return edge && edge.in ? edge.in : null;
}

function normalizeChildren(edges, classToFind) {
  return (edges || [])
    .map(getChildVertex)
    .filter(function (vertex) {
      return vertex && vertex['@class'] == classToFind;
    });
}

var trees = {};

trees.oninit = function (vnode) {
  var ctrl = this;
  ctrl.selector = vnode.attrs.selector;
  ctrl.node = prop({});
  ctrl.activeTree = prop({});
  ctrl.newNode = prop(false);
  ctrl.dataToShow = [];

  ctrl.getRoots = function () {
    ctrl.node({children:[]});
    Promise.resolve(
      loaders.requestWithLoader({
        loader: 'background',
        url: 'api/v1/dashboard',
        method: 'GET'
      })
    ).then(function (results) {
      ctrl.roots = normalizeChildren(results['out_Contains'], 'Site');
      ctrl.node({children: ctrl.roots, ancestors: [{name: 'Home'}]});
      ctrl.newNode(true);
    })
  }

  ctrl.home = function () {
    ctrl.node({children: ctrl.roots});
    ctrl.newNode(true);
  }

  ctrl.navigateNode = function (node) {
    return loaders.requestWithLoader({
      loader: 'background',
      url: urlForRecord(node),
      method: 'GET'
    })
    .then(function (res) {
      var outEdge, classToFind;
      if(res['@class'] == 'Dashboard'){
        outEdge = 'out_Contains';
        classToFind = 'Site';
      }
      if(res['@class'] == 'Site') {
        outEdge = 'out_isSiteOf';
        classToFind = 'Building';
      }
      if(res['@class'] == 'Building') {
        outEdge = 'out_hasPart';
        classToFind = 'Level';
      }
      if(res['@class'] == 'Level') {
        outEdge = 'out_hasPart';
        classToFind = 'Room';
      }
      var children = normalizeChildren(res[outEdge], classToFind);
      ctrl.node({children, ancestors: res['@class'] == 'Dashboard' ? [{name: 'Home'}] : res.path.reverse()});
      ctrl.newNode(true);
    });
  }

  ctrl.selectNode = function (node) {
    return ctrl.selector(node)
  }

  ctrl.getRoots();
}

trees.view = function () {
  var ctrl = this;

  var ancestors = ctrl.node().ancestors;
  var children = ctrl.node().children;

  return m('div.mb2', [
    m('label', 'Select Location:'),
    m('br'),
    m("div.mb3.pb2.bb.bw1.b--mid-gray.near-white",  [
      m('div.dib-ns.mr2', {label: 'Home', onclick: ctrl.home}),
      function () {
        if (ancestors) {
          return ancestors.map(function (ancestor, idx){
            return m('div.dib-ns.mr2', {
              class:(idx+1) === ctrl.node().ancestors.length ? "active" : "blue", 
              onclick: ctrl.navigateNode.bind(this, ancestor.name == 'root' ? undefined : ancestor), 
            }, [
              ancestor.name == 'root' ? 'Home' : ancestor.name,
              ' / '
            ])
          })        
        }
      }()
    ]),
    m(paginationWithSearch, {
      data: children || [],
      dataToShow: ctrl.dataToShow,
      newNode: ctrl.newNode,
      placeHolder: 'Search location',
      fieldsToSearch: ['name', 'roomNumber']
    }, [
    m('div', ctrl.dataToShow.map(function (vertex, idx) {
      var outEdge, classToFind;
      if (!vertex || !vertex['@rid']) return;

      if(vertex['@class'] == 'Site') {
        outEdge = 'out_isSiteOf';
        classToFind = 'Building';
      }
      if(vertex['@class'] == 'Building') {
        outEdge = 'out_hasPart';
        classToFind = 'Level';
      }
      if(vertex['@class'] == 'Level') {
        outEdge = 'out_hasPart';
        classToFind = 'Room';
      }
      if (vertex[outEdge] && vertex[outEdge].length > 0) {
        return m(verticalListItem, 
        {
          onclickLabel: ctrl.navigateNode.bind(this, vertex),
          label: m('span',[
            vertex.name, 
            m('i', {class: 'dark-blue ion-ios-arrow-right ml2 f3 b'})
          ]),
          labelClass: 'dark-blue'
        },[
          m('i', {onclick: ctrl.selectNode.bind(this, vertex), class: 'fr f3 b ' + (ctrl.selector()['@rid'] === vertex['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')})
        ])
      }else { 
        return m(verticalListItem, {label: vertex.name},[
          m('i', {onclick: ctrl.selectNode.bind(this, vertex), class: 'fr f3 b ' + (ctrl.selector()['@rid'] === vertex['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')})
        ])
      }
      
    }))
    ])
  ])
}

module.exports = trees;
